import React, { type FC } from "react";
import NiceModal, {
  type NiceModalHocProps,
  useModal
} from "@ebay/nice-modal-react";
import KC_Modal_2 from "../../../designsystem/KC_Modal/KC_Modal_2";
import KC_Heading3 from "../../../designsystem/typography/KC-Heading/KC_Heading3";
import { tt } from "../../../utils/i18n/i18n";
import KC_Button, {
  KC_ButtonSize
} from "../../../designsystem/KC_Button/KC_Button";
import POSAList from "../../../app/19_JetpackConfig/components/POSDisplay/component/POSAList";
import "./styles.scss";

interface Props {
  resolveModal: (value: boolean) => void;
}

const ConfirmPaymentPLVOrder: FC<Props & NiceModalHocProps> =
  NiceModal.create<Props>((props) => {
    const modal = useModal();

    const handleClose = () => {
      props.resolveModal(false);
      void modal.hide();
    };

    const handleConfirm = (value: boolean) => {
      props.resolveModal(value);
      void modal.hide();
    };

    return (
      <KC_Modal_2
        id="confirm-posa-order"
        isOpen={modal.visible}
        onClose={handleClose}
        hideCloseButton={false}
        header={
          <div className={"w-100 py-2 px-3"}>
            <KC_Heading3 text={tt("confirm_plv_order")} />
          </div>
        }
        footer={
          <div className="w-100 d-flex justify-content-end st-gap">
            <div>
              <KC_Button
                isInverted={true}
                onClick={() => {
                  handleConfirm(false);
                }}
                size={KC_ButtonSize.Large}
                text={tt("confirm_plv_order_back_button")}
                className="d-flex"
              />
            </div>
            <div>
              <KC_Button
                id={"Confirm-payment-modal-next-btn"}
                isPrimary={true}
                onClick={() => {
                  handleConfirm(true);
                }}
                size={KC_ButtonSize.Large}
                text={tt("confirm_plv_order_place_order_button")}
                className="d-flex"
              />
            </div>
          </div>
        }
      >
        <POSAList isModal={true} />
      </KC_Modal_2>
    );
  });

export default ConfirmPaymentPLVOrder;
